export const PC_HANDHELDS_HARDWARE = [
    {
  id: "pc-gaming",
  name: "PC Gaming",
  brand: "PC",
  type: "console",
  category: "PC",
  variants: [
    {
      id: "gaming-pc",
      name: "Gaming PC",
      versions: [
        {
          id: "desktop-pc",
          name: "PC Fixe Gaming",
          storage: "",
          disc: false,
          image: "/images/consoles/gaming-pc.png",
        },
        {
          id: "gaming-laptop",
          name: "PC Portable Gaming",
          storage: "",
          disc: false,
          image: "/images/consoles/gaming-laptop.png",
        },
      ],
    },
  ],
},

{
  id: "steam-deck",
  name: "Steam Deck",
  brand: "PC",
  type: "console",
  category: "PC",
  variants: [
    {
      id: "steam-deck-models",
      name: "Steam Deck",
      versions: [
        {
          id: "steam-deck-64",
          name: "Steam Deck 64 Go",
          storage: "64 Go",
          disc: false,
          image: "/images/consoles/steam-deck.png",
        },
        {
          id: "steam-deck-256",
          name: "Steam Deck 256 Go",
          storage: "256 Go",
          disc: false,
          image: "/images/consoles/steam-deck.png",
        },
        {
          id: "steam-deck-oled-512",
          name: "Steam Deck OLED 512 Go",
          storage: "512 Go",
          disc: false,
          image: "/images/consoles/steam-deck-oled.png",
        },
        {
          id: "steam-deck-oled-1tb",
          name: "Steam Deck OLED 1 To",
          storage: "1 To",
          disc: false,
          image: "/images/consoles/steam-deck-oled.png",
        },
      ],
    },
  ],
},

{
  id: "steam-machine",
  name: "Steam Machine",
  brand: "Valve",
  type: "console",
  category: "PC",
  variants: [
    {
      id: "steam-machine-valve",
      name: "Steam Machine",
      versions: [
        {
          id: "steam-machine-2026",
          name: "Steam Machine 2026",
          storage: "",
          disc: false,
          image: "/images/consoles/steam-machine-2026.png",
        },
      ],
    },
    {
      id: "steam-machine-legacy",
      name: "Steam Machine Legacy",
      versions: [
        {
          id: "steam-machine-original",
          name: "Steam Machine",
          storage: "",
          disc: false,
          image: "/images/consoles/steam-machine.png",
        },
      ],
    },
  ],
},

{
  id: "rog-ally",
  name: "ROG Ally",
  brand: "PC",
  type: "console",
  category: "PC",
  variants: [
    {
      id: "rog-ally-models",
      name: "ROG Ally",
      versions: [
        {
          id: "rog-ally-z1",
          name: "ROG Ally Z1",
          storage: "512 Go",
          disc: false,
          image: "/images/consoles/rog-ally.png",
        },
        {
          id: "rog-ally-z1-extreme",
          name: "ROG Ally Z1 Extreme",
          storage: "512 Go",
          disc: false,
          image: "/images/consoles/rog-ally.png",
        },
      ],
    },
  ],
},
{
  id: "pc-handhelds",
  name: "PC Handheld",
  brand: "PC",
  type: "console",
  category: "PC",
  variants: [
    {
      id: "pc-handheld-family",
      name: "Handheld PC",
      versions: [
        {
          id: "legion-go",
          name: "Lenovo Legion Go",
          storage: "512 Go",
          disc: false,
          image: "/images/consoles/legion-go.png",
        },
        {
          id: "msi-claw",
          name: "MSI Claw",
          storage: "1 To",
          disc: false,
          image: "/images/consoles/msi-claw.png",
        },
        {
          id: "logitech-g-cloud",
          name: "Logitech G Cloud",
          storage: "64 Go",
          disc: false,
          image: "/images/consoles/logitech-g-cloud.png",
        },
        {
          id: "aya-neo",
          name: "AYANEO",
          storage: "1 To",
          disc: false,
          image: "/images/consoles/aya-neo.png",
        },
      ],
    },
  ],
},
{
  id: "apple-mac-gaming",
  name: "Apple Mac",
  brand: "Apple",
  type: "console",
  category: "PC",
  variants: [
    {
      id: "apple-mac-desktop",
      name: "Mac de bureau",
      versions: [
        {
          id: "mac-mini-m4",
          name: "Mac mini M4",
          storage: "",
          disc: false,
          image: "/images/consoles/mac-mini-m4.png",
        },
        {
          id: "mac-mini-m4-pro",
          name: "Mac mini M4 Pro",
          storage: "",
          disc: false,
          image: "/images/consoles/mac-mini-m4-pro.png",
        },
        {
          id: "mac-studio-m4-max",
          name: "Mac Studio M4 Max",
          storage: "",
          disc: false,
          image: "/images/consoles/mac-studio-m4-max.png",
        },
        {
          id: "mac-studio-m3-ultra",
          name: "Mac Studio M3 Ultra",
          storage: "",
          disc: false,
          image: "/images/consoles/mac-studio-m3-ultra.png",
        },
      ],
    },
    {
      id: "apple-macbook-pro",
      name: "MacBook Pro",
      versions: [
        {
          id: "macbook-pro-14-m4-pro",
          name: "MacBook Pro 14 M4 Pro",
          storage: "",
          disc: false,
          image: "/images/consoles/macbook-pro-14-m4-pro.png",
        },
        {
          id: "macbook-pro-14-m4-max",
          name: "MacBook Pro 14 M4 Max",
          storage: "",
          disc: false,
          image: "/images/consoles/macbook-pro-14-m4-max.png",
        },
        {
          id: "macbook-pro-16-m4-pro",
          name: "MacBook Pro 16 M4 Pro",
          storage: "",
          disc: false,
          image: "/images/consoles/macbook-pro-16-m4-pro.png",
        },
        {
          id: "macbook-pro-16-m4-max",
          name: "MacBook Pro 16 M4 Max",
          storage: "",
          disc: false,
          image: "/images/consoles/macbook-pro-16-m4-max.png",
        },
      ],
    },
  ],
},
]
